import { FC, memo } from 'react'
import { Select, SelectProps } from '@chakra-ui/react'

import { FilterGroupInputsProps } from 'components/miscellaneous/FilterGroups/FilterGroupForInputs'

type Props = FilterGroupInputsProps & SelectProps

const CustomSelect: FC<Props> = ({ options, optionLabelKey = 'label', optionValueKey = 'value', ...rest }) => {
  return (
    <Select {...rest}>
      {options && (
        <>
          {options.map((option: any, index: number) => {
            const value = option[optionValueKey]
            const label = option[optionLabelKey] === '' ? 'Todos' : option[optionLabelKey]

            return (
              <option key={index} value={value}>
                {label}
              </option>
            )
          })}
        </>
      )}
    </Select>
  )
}

export default memo(CustomSelect)
